import React from 'react';
import './StateHistoryTab.scss';
import { StateHistory } from '@/data/models/stateHistory';
import { parseDateTimeString } from '@/utils/helper';
import useAuthUtilities from '../../../../AuthMiddleware/AuthUtilities';
import {
  getAlbumStateBadgeClass,
  getChangeRequestDetailsUrl,
} from '../../../common/ProductUtilities';
import { useTranslation } from 'react-i18next';
import { IAlbum } from '@/data/models/album';
import { Link } from 'react-router-dom';

interface StateHistoryProps {
  stateHistory: StateHistory[];
  album?: IAlbum;
}

export default function StateHistoryTab({
  stateHistory,
  album,
}: StateHistoryProps) {
  const { canUserViewInternalFields } = useAuthUtilities();
  const { t } = useTranslation();
  const sortedStateHistory = [...stateHistory].sort((x, y) =>
    x.timestamp > y.timestamp ? -1 : 1
  );

  return (
    <>
      {sortedStateHistory.map((history, index) => {
        const historyNotes = history.changeRequestId ? (
          <>
            {t('product.stateHistory.changeRequestApplied')}
            {history.changeRequestId ? (
              <span>
                {' '}
                (
                <Link
                  to={getChangeRequestDetailsUrl(
                    album?.id,
                    history.changeRequestId,
                    !!album?.merchandiseMetadata
                  )}
                >
                  {t('common.generic.view')}
                </Link>
                )
              </span>
            ) : null}
          </>
        ) : (
          history.notes
        );

        return (
          <div className="state-history" key={index}>
            <div className="state-history-timestamp">
              <span className="timestamp-bold">
                {parseDateTimeString(history.timestamp.toString())}
              </span>
              {canUserViewInternalFields() ? (
                <span className="user-normal">
                  &nbsp;{`(${history.userName})`}
                </span>
              ) : null}
            </div>
            {!history.changeRequestId && (
              <div>
                {history.oldState ? (
                  <>
                    <div
                      className={`badge state-badge ${getAlbumStateBadgeClass(history.oldState)}`}
                    >
                      {t(`product.${history.oldState}`)}
                    </div>
                    &nbsp;
                    <i className="icon fas fa-long-arrow-right"></i>
                    &nbsp;
                  </>
                ) : null}
                <div
                  className={`badge state-badge ${getAlbumStateBadgeClass(history.newState)}`}
                >
                  {t(`product.${history.newState}`)}
                </div>
              </div>
            )}
            {historyNotes && (
              <div className="history-notes">{historyNotes}</div>
            )}
          </div>
        );
      })}
    </>
  );
}
